module.exports = __webpack_public_path__ + "images/assets/9ed5ed2d101a013b31a0cab518e51979.svg";